module.exports = __webpack_public_path__ + "amazon.png?001a5bcad3dca205dca0d0409e61f02d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconImg/amazon.png
// module id = 119
// module chunks = 0